var Events = require('f.core.event');
require('./style.css');
var tmpl = require('./main.ejs');

var MiniInput = function(options) {
    this.desc = options.desc || '我要说两句';
    this.value = '';
    this.isAdmire = false;
    this.init();
    this.isClear = false;
};

MiniInput.prototype.init = function() {
    this.initDom();
    this.initEvent();
};

MiniInput.prototype.initDom = function() {
    this.el = $(tmpl({ desc: this.desc }));
    this.eltalk = this.el.filter('.c-talk');
    this.elclear = this.el.filter('.c-talk__clear');
    this.elInput = this.eltalk.find('.c-talk__input span');
    this.elcollect = this.el.find('.c-talk__collect');
    
};

MiniInput.prototype.initEvent = function() {
    this.eltalk.on(
        'touchend',
        '.c-talk__input',
        function() {
            this.trigger('click');
            return false;
        }.bind(this),
    );

    this.eltalk.on(
        'touchend',
        '.c-talk__share',
        function() {
            this.trigger('share');
            return false;
        }.bind(this),
    );

    this.eltalk.on(
        'touchend',
        '.c-talk__gift',
        function() {
            this.trigger('gift');
            return false;
        }.bind(this),
    );
    this.eltalk.on(
        'touchend',
        '.c-talk__collect',
        function() {
            var sta = true;
            if(this.elcollect && this.elcollect.hasClass('c-talk__collected')){
                sta = false;
            }
            this.trigger('collect', sta);
            return false;
        }.bind(this),
    );
    this.eltalk.on(
        'touchend',
        '.c-talk__back',
        function() {
            this.trigger('exit');
            return false;
        }.bind(this),
    );

    this.elclear.on(
        'touchend',
        function() {
            if (!this.isClear) {
                this.clear();
            } else {
                this.unclear();
            }
            return false;
        }.bind(this),
    );
};

MiniInput.prototype.hide = function() {
    this.eltalk.stop().animate({
        opacity: '0',
    });
    this.eltalk.addClass('nopointer');
    this.elclear.stop().animate({
        opacity: '0',
    });
};

MiniInput.prototype.text = function(val) {
    val = val || this.desc;
    this.elInput.text(val);
    if(val){
        this.value = val;
    }
};

MiniInput.prototype.isCollected = function() {
    if(!this.elcollect.hasClass('c-talk__collected')){
        this.elcollect.addClass('c-talk__collected');
    }
};
MiniInput.prototype.collect = function(sta) {
    if(this.elcollect.hasClass('c-talk__collect_scale')){
        this.elcollect.removeClass('c-talk__collect_scale')
    }
    if(this.elcollect.hasClass('c-talk__collect_scale1')){
        this.elcollect.removeClass('c-talk__collect_scale1')
    }
    if(sta){
        this.elcollect.addClass('c-talk__collect_scale').addClass('c-talk__collected')
    }else{
        this.elcollect.addClass('c-talk__collect_scale1').removeClass('c-talk__collected');
    }
};

MiniInput.prototype.show = function() {
    this.eltalk.stop().animate({
        opacity: '1',
    });
    this.eltalk.removeClass('nopointer');
    this.elclear.stop().animate({
        opacity: '1',
    });
};

MiniInput.prototype.hideShare = function() {
    $(this.eltalk).find('.c-talk__share').hide();
};

MiniInput.prototype.hideInputAndGift = function() {
    $(this.eltalk).find('.c-talk__input').hide();
    $(this.eltalk).find('.c-talk__gift').hide();
};

MiniInput.prototype.showInput = function() {
    $(this.eltalk).find('.c-talk__input').show();
    $(this.eltalk).find('.c-talk__gift').show();
};

MiniInput.prototype.hideMiniInput = function() {
    $(this.eltalk).hide();
};

MiniInput.prototype.showMiniInput = function() {
    $(this.eltalk).show();
};
MiniInput.prototype.checkIsCollected = function() {
    this.trigger('check_isCollected');
};

MiniInput.prototype.showBackAndShare = function() {
    // $(this.eltalk).find('.c-talk__back').show();
    $(this.eltalk).find('.c-talk__hold').show();
    // $(this.eltalk).find('.c-talk__shift').show();
};

MiniInput.prototype.hideBackAndShare = function() {
    // $(this.eltalk).find('.c-talk__back').hide();
    $(this.eltalk).find('.c-talk__hold').hide();
};

MiniInput.prototype.hideCollect = function() {
    this.elcollect.hide();
};

MiniInput.prototype.showCollect = function() {
    this.elcollect.show();
};

MiniInput.prototype.clear = function() {
    this.elclear.addClass('unclear');
    this.isClear = true;
    this.trigger('clear');
};

MiniInput.prototype.unclear = function() {
    this.elclear.removeClass('unclear');
    this.trigger('unclear');
    this.isClear = false;
};

MiniInput.prototype.renderTo = function(parentNode) {
    $(parentNode).append(this.el);
};

Events.mixTo(MiniInput);
module.exports = MiniInput;



// WEBPACK FOOTER //
// ./app/modules/miniInput/index.js